import { render, staticRenderFns } from "./AppAside.vue?vue&type=template&id=7a195088&scoped=true"
import script from "./AppAside.vue?vue&type=script&lang=js"
export * from "./AppAside.vue?vue&type=script&lang=js"
import style0 from "./AppAside.vue?vue&type=style&index=0&id=7a195088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a195088",
  null
  
)

export default component.exports